import { render } from "./PagerPageNumber.vue?vue&type=template&id=2c5e2b58&scoped=true&ts=true"
import script from "./PagerPageNumber.vue?vue&type=script&lang=ts"
export * from "./PagerPageNumber.vue?vue&type=script&lang=ts"

import "./PagerPageNumber.vue?vue&type=style&index=0&id=2c5e2b58&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5e2b58"]])

export default __exports__